<template>
  <div id="login">

    <mt-header title="登录" style="height: 50px">
      <router-link :to="path" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
      <router-link to="/register" slot="right">
        <mt-button  style="color: #666666">注册</mt-button>
      </router-link>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="login-content">
      <div class="textfield-view">
        <input type="text"
               style="color:#191919"
               v-model="phonteNum"
               placeholder="手机号码"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view">
        <input type="password"
               style="color:#191919"
               v-model="password"
               placeholder="密码"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="button" @click="login">
        手机号登录
      </div>

      <div class="login-footer">
        <router-link to="/forgetPassword">
          <span class="go">忘记密码?</span>
        </router-link>

        <router-link to="/phoneNumlogin" :replace="true">
          <span class="go">手机号码快捷登录</span>
        </router-link>

      </div>
    </div>


  </div>
</template>

<script>
  //  import { MessageBox } from 'mint-ui'
  import api from '../../../api/common/api.common'
  import cookieTools from '../../../js/cookie'
  export default {
    name: 'myBill',
    mounted () {
    },
    destroyed () {
    },
    computed: {
      path () {
        if (this.$route.query['url'] !== undefined) {
          console.log(this.$route.query['url'])
          return this.$route.query['url']
        }

        return '/'
      }
    },
    data () {
      return {
        phonteNum: '',
        password: ''
      }
    },
    methods: {
      login () {
        if (!this.utils.isMobileNum(this.phonteNum)) {
          this.utils.alert('请填写正确的手机号')
          return
        }
        var data = {}
        data.loginType = 0
        data.mobilePhone = this.phonteNum
        data.password = this.password
        var self = this
        api.login(data,function (successRespond) {
          self.$store.dispatch('setLogin',true)
          localStorage.setItem('userIsLogin', true);
          localStorage.setItem('userloginTime', new Date());
          localStorage.setItem('loginCredentials', successRespond.body.data['loginCredentials']);
          //
//          cookieTools.set("user-isLogin-cache", true);
//          cookieTools.set("user-loginTime-cache", new Date());
//          self.$router.push(self.path)
            self.$router.replace(self.path)
        })

      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';

  .login-content {
    margin-top: pxToRem(60px);
  }

  .textfield-view {

    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
  }

  .textfield {
    margin-top: pxToRem(60px);
    margin-bottom: pxToRem(30px);
    width: 100%;
  }
  .button {
    background: #3D2D23;
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    text-align: center;
    color: white;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(80px);
    font-size: pxToRem(28px);
  }
  .login-footer {
    display: flex;
    justify-content: space-between;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(60px);
    color: #666666;
    font-size: pxToRem(24px);
  }
  .go {
    color: #666666;
  }
</style>


// WEBPACK FOOTER //
// login.vue?423a89a0